import { getGoogleMaps } from "../../util/general_util";

export function openRouteInGoogleMapsApp(
	locations:Array<string|{latitude:number,longitude:number}>
  ): void {
	const locationStrings = locations.map(location =>
		typeof location === 'string'
		  ? encodeURIComponent(location)
		  : `${location.latitude},${location.longitude}`
	  );

	const url = `https://www.google.com/maps/dir/${locationStrings.join('/')}`;

	window.open(url, '_blank');
};

export function addMarker_googleMap(map:google.maps.Map, lat:number, lng:number) {
	let latLng:google.maps.LatLng = new google.maps.LatLng(lat, lng);
	let marker:google.maps.Marker = new google.maps.Marker({
		position: latLng,
		map: map,
	});
};

export async function initMap_googleMaps(elID:string, mapTypeId:string, lat:number, lng:number, zoomLevel:number):Promise<google.maps.Map> {
	let map: google.maps.Map;
	const maps:typeof google.maps = await getGoogleMaps();

	map = new maps.Map(
		document.getElementById(elID),
		{
			zoom: zoomLevel,
			center: {lat:lat, lng:lng},
			mapTypeId: mapTypeId
		}
	);

	return map;
};